import React, { useState,useCallback } from 'react';
import { Button } from 'react-bootstrap';
import UserDatatable from '../../modules/user/UserDatatable';
import UserModal from '../../modules/user/UserModal';



const UserTab = (props) => {

    
    const [show , setShow]= useState( false );
    const [recordId, setRecordId ] = useState( "" );
    
    
  

    const handleCallback = useCallback(
      (id) => {
          setRecordId(id);       
          setShow(true);   
      },
      [], 
    );
 
    const modalCallback = (show) => {             
      setShow(show);           
    }

  
    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
        
          <UserDatatable
            
            parentCallback={handleCallback}
            entityId={props.entityId}
            //refreshTable={dataChanged}           
            modalShow={show}             
          />
         
          <UserModal 
            show={show}
            parentCallback={modalCallback}
            selectedRecord={recordId}
            entityId={props.entityId}         
          />
         
          <Button
        //    bsStyle="primary"
          //  bsSize="large"
            className="ml-3 mt-3"
            onClick={() => handleCallback('')} //current => !current
          >
            <i className="fas fa-plus"></i>
          </Button>
        </div>
    );
};

export default UserTab;